<template>
  <div class="form-group">
    <div class="label required fs-xl">Assignment type</div>
    <div class="row">
      <div class="col-12 col-md-6">
        <input id="batch_type" v-model="assignmentType" name="assignment_type" type="radio" :value="CONSOLIDATE" />
        <label for="batch_type" class="radio-group">
          <span class="radio-title"> Batch shipment (Upload file) </span>
        </label>
      </div>
      <div class="col-12 col-md-6">
        <input id="single_type" v-model="assignmentType" name="assignment_type" type="radio" :value="SINGLE" />
        <label for="single_type" class="radio-group">
          <span class="radio-title">Single package (Enter address)</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, type ComputedRef, defineComponent, type Ref, ref, watch } from 'vue'
import { CONSOLIDATE, SINGLE } from '@/const/AssignmentTypes'
import { useAssignmentFormStore } from '@/store/assignmentForm'

export default defineComponent({
  name: 'AssignmentType',
  setup() {
    const assignmentFormStore = useAssignmentFormStore()

    const type: ComputedRef<string> = computed(() => assignmentFormStore.assignment.assignment_type)
    const assignmentType: Ref<string> = ref(CONSOLIDATE)

    watch(assignmentType, (value) => assignmentFormStore.setFields({ assignment_type: value }))
    watch(type, (value) => {
      if (assignmentType.value !== value) {
        assignmentType.value = value
      }
      if (value === SINGLE) {
        assignmentFormStore.setFields({ file: null })
      }
    })

    return {
      assignmentType,
      SINGLE,
      CONSOLIDATE,
    }
  },
})
</script>
